/* Integromate will also use this component */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ZAPIER } from 'drapcode-constant';
import * as actions from '../../../features/external-api/redux/actions';
import CollectionMapping from '../CollectionMapping';
import { iconForField } from '../../../common/custom/icon-library';

export class ZapierExternalApiForm extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    externalApiName: '',
    url: '',
    methodType: 'POST',
    nameError: '',
    enabled: false,
  };

  componentDidMount() {
    const { externalApiId } = this.props;
    const { externalApiData } = this.props.externalapi;
    if (externalApiId && externalApiData && externalApiData.externalApiType === ZAPIER) {
      this.setState({
        externalApiName: externalApiData.externalApiName,
        url: externalApiData.setting.url,
        methodType: externalApiData.setting.methodType,
        enabled: externalApiData.setting.enabled,
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    let nameError = '';
    if (name === 'externalApiName') {
      nameError = value.length > 100 ? 'Name can not be more than 100 characters' : '';
    }
    this.setState({ [name]: value, nameError });
  };

  isValidationError = () => {
    const { externalApiName, url, nameError } = this.state;
    let isError = false;
    if (externalApiName === '' || !externalApiName) {
      this.setState({ nameError: 'This field is required' });
      isError = true;
    }
    if (externalApiName.length > 100) {
      this.setState({ nameError: 'Name can not be more than 100 characters' });
      isError = true;
    }
    if (nameError) {
      isError = true;
    }
    return isError;
  };

  handleSubmit = (values) => {
    const { projectId, externalApiId, externalApiType, version } = this.props;
    const { methodType, url, externalApiName, enabled } = this.state;
    if (this.isValidationError()) {
      return;
    }
    let formData = {};
    formData.collectionName = values.selectedCollectionName;
    formData.collectionMapping = values.collectionMappingObject;
    formData.projectId = projectId;
    formData.version = version;
    formData.externalApiName = externalApiName;
    formData.externalApiType = externalApiType;
    formData.setting = {
      methodType,
      url,
      headers: [],
      params: [],
      currentUserParams: [],
      authType: '',
      requestHeader: '',
      enabled,
    };
    if (externalApiId) {
      formData.externalApiId = externalApiId;
      this.props.actions.updateExternalApi(formData).then(() => {
        this.props.history.push(`/2.0/externalapi/${version}/v/${projectId}/zapier`);
      });
    } else {
      this.props.actions.createExternalApi(formData).then(() => {
        this.props.history.push(`/2.0/externalapi/${version}/v/${projectId}/zapier`);
      });
    }
  };

  render() {
    const { externalApiId, externalApiType, projectId, home } = this.props;
    const { externalApiName, url, nameError } = this.state;
    return (
      <div className="row pb-3">
        <div className="col-12">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('text')}`}></i>
                </span>
              </div>

              <input
                type="text"
                name="externalApiName"
                className="form-control form-control-sm"
                onChange={this.handleChange}
                value={externalApiName}
                placeholder="Name"
              />

              {nameError && <p className="errors">{nameError}</p>}
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="URL">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('url')}`}></i>
                </span>
              </div>
              <input
                name="url"
                type="text"
                className="form-control form-control-sm bg-white"
                value={url}
                placeholder="External API URL"
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="col-12 ">
          <CollectionMapping
            handleSubmit={this.handleSubmit}
            externalApiId={externalApiId}
            externalApiType={externalApiType}
            projectDetail={home.projectDetail}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ZapierExternalApiForm);
